module.exports = __webpack_public_path__ + "static/media/copy.f9974347.svg";